import React, { useRef } from 'react';
import { useWidthResizableField } from '../../../hook/useWidthResizableField';

export const SubmittersFieldElement = function FromElement({ element, setPosition }) {
  const fieldRef = useRef();

  useWidthResizableField(fieldRef, element, setPosition);

  return (
    <>
      <label className="form-label">
        {element.options.name ? element.options.name : `Select${element.options.labels.length > 0 && 'ed'} Submitters Field`}
      </label>
      <p ref={fieldRef} className={'form-submitters'}>
        {element.options.labels.map((item) => item.label).join(' ')}
      </p>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
